import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 13,
	viewBox: "0 0 11 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.4375 2.375H8.67969L7.88281 1.0625C7.67188 0.710938 7.32031 0.5 6.92188 0.5H4.55469C4.15625 0.5 3.80469 0.710938 3.59375 1.0625L2.79688 2.375H1.0625C0.734375 2.375 0.5 2.63281 0.5 2.9375C0.5 3.26562 0.734375 3.5 1.0625 3.5H1.25L1.74219 11.4453C1.76562 12.0547 2.25781 12.5 2.86719 12.5H8.60938C9.21875 12.5 9.71094 12.0547 9.73438 11.4453L10.25 3.5H10.4375C10.7422 3.5 11 3.26562 11 2.9375C11 2.63281 10.7422 2.375 10.4375 2.375ZM4.55469 1.625H6.92188L7.36719 2.375H4.10938L4.55469 1.625ZM8.60938 11.375H2.86719L2.375 3.5H9.10156L8.60938 11.375Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
